import action from "../middleware";

export const CATEGORY_LOADED = "CATEGORY_LOADED";
export const CATEGORY_FILTERED = "CATEGORY_FILTERED";
export const CATEGORY_FILTERED_OUT = "CATEGORY_FILTERED_UT";
export const AWS_ACCOUNT_FILTERED = "AWS_ACCOUNT_FILTERED";
export const AWS_ACCOUNT_FILTERED_OUT = "AWS_ACCOUNT_FILTERED_OUT";

export const INIT_ENVIRONMENT_FILTERS = "INIT_ENVIRONMENT_FILTERS";
export const ENVIRONMENT_FILTERED = "ENVIRONMENT_FILTERED";
export const ENVIRONMENT_FILTERED_OUT = "ENVIRONMENT_FILTERED_OUT";

export const UNMANAGED_CHANGE_FILTER_STATUS =  "UNMANAGED_CHANGE_FILTER_STATUS";

const onCategoryLoaded = (categoryId) => {
    return action(async dispatch => {

        dispatch({
            type: CATEGORY_LOADED,
            payload: { categoryId }
        });
    });
}

const onCategoryFiltered = (resourceTypes) => {
    return action(async dispatch => {

        dispatch({
            type: CATEGORY_FILTERED,
            payload: { resourceTypes }
        });
    });
}

const onCategoryFilteredOut = (resourceTypes) => {
    return action(async dispatch => {

        dispatch({
            type: CATEGORY_FILTERED_OUT,
            payload: { resourceTypes }
        });
    });
}

const onAwsAccountFiltered = (awsAccount) => {
    return action(async dispatch => {

        dispatch({
            type: AWS_ACCOUNT_FILTERED,
            payload: { awsAccount }
        });
    });
}

const onAwsAccountFilteredOut = (awsAccount) => {
    return action(async dispatch => {

        dispatch({
            type: AWS_ACCOUNT_FILTERED_OUT,
            payload: { awsAccount }
        });
    });
}

const initEnvironmentFilters = (environmentIds) => {
    return action(async dispatch => {

        dispatch({
            type: INIT_ENVIRONMENT_FILTERS,
            payload: { environmentIds }
        });
    });
}

const onEnvironmentFiltered = (environmentId) => {
    return action(async dispatch => {

        dispatch({
            type: ENVIRONMENT_FILTERED,
            payload: { environmentId }
        });
    });
}

const onEnvironmentFilteredOut = (environmentId) => {
    return action(async dispatch => {

        dispatch({
            type: ENVIRONMENT_FILTERED_OUT,
            payload: { environmentId }
        });
    });
}

const onChangeUnmanagedFilterStatus = (filtered) => {
    return action(async dispatch => {

        dispatch({
            type: UNMANAGED_CHANGE_FILTER_STATUS,
            payload: { filteredUnmanaged: filtered }
        });
    });
}



export {
    onCategoryLoaded,
    onCategoryFiltered,
    onCategoryFilteredOut,
    onAwsAccountFiltered,
    onAwsAccountFilteredOut,
    onEnvironmentFiltered,
    onEnvironmentFilteredOut,
    initEnvironmentFilters,
    onChangeUnmanagedFilterStatus
}
